import { getSurveyOptions } from "@pulse/api/queryApi";
import { SurveyProvider } from "@pulse/contexts/SurveyProvider";
import { queryClient } from "@pulse/queryClient";
import { createFileRoute, notFound, Outlet, rootRouteId } from "@tanstack/react-router";

export const Route = createFileRoute("/_hub/$customerId/pulse/$pulseId/surveys/$surveyId")({
    component: RouteComponent,
    staticData: {
        titleFn: null,
    },
    loader: async ({ params }) => {
        await queryClient
            .ensureQueryData(getSurveyOptions({ surveyId: +params.surveyId }))
            .then((survey) => {
                if (survey.pulseInstanceId !== +params.pulseId) {
                    throw new Error(`Survey with id ${params.surveyId} not found`);
                }
            })
            .catch(() => {
                throw notFound({ routeId: rootRouteId });
            });
    },
});

function RouteComponent() {
    const { surveyId } = Route.useParams();

    return (
        <SurveyProvider id={Number(surveyId)}>
            <Outlet />
        </SurveyProvider>
    );
}
